import { Comments } from '@/components/comments/Comments/Comments';
import {
  useComments,
  useCreateComment,
  useDeleteComment,
  useUpdateComment,
} from '@/models/shipment';

export const ShipmentComments = ({ shipmentId }: { shipmentId: string }) => {
  const { data: { comments } = { comments: [] } } = useComments({ shipmentId });
  const { mutateAsync: sendCreateComment } = useCreateComment({ shipmentId });
  const { mutateAsync: sendUpdateComment } = useUpdateComment({ shipmentId });
  const { mutateAsync: sendDeleteComment } = useDeleteComment({ shipmentId });

  return (
    <Comments
      comments={comments}
      onCommentCreated={async (data) => {
        await sendCreateComment(data);
      }}
      onCommentUpdated={async (data) => {
        await sendUpdateComment(data);
      }}
      onCommentDeleted={async (data) => {
        await sendDeleteComment(data);
      }}
    />
  );
};
